import { render, staticRenderFns } from "./VisualSettings.vue?vue&type=template&id=2f09cb83&scoped=true"
import script from "./VisualSettings.vue?vue&type=script&lang=js"
export * from "./VisualSettings.vue?vue&type=script&lang=js"
import style0 from "./VisualSettings.vue?vue&type=style&index=0&id=2f09cb83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f09cb83",
  null
  
)

export default component.exports